import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";
import { dateTime, titleCase } from "@/lib/format";

const PURPOSES = [
  ["marketing_email", "Email marketing", "New arrivals, private previews and editorial. You can unsubscribe at any time."],
  ["marketing_sms", "SMS marketing", "Important VIP drops and shipping alerts. Only when enabled."],
  ["analytics", "Analytics", "Helps us understand how the store is used. No analytics provider is configured yet, so nothing is sent."],
  ["personalization", "Personalisation", "Remembers recently viewed products and tailors the editorial we show you."],
];

export default function AccountConsents() {
  const { data, reload } = useFetch("/account/consents");
  const current = data?.current || {};
  const history = data?.history || [];
  const change = async (purpose, granted) => {
    try {
      await api.post("/account/consents", { purpose, granted, source: "account_preferences" });
      toast.success(`${titleCase(purpose)} ${granted ? "enabled" : "disabled"}`);
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="max-w-xl" data-testid="account-consents">
      <h2 className="font-display text-3xl">Marketing & privacy</h2>
      <p className="text-sm text-muted-foreground mt-2">Choose how you'd like to hear from us. We record every choice in your consent history.</p>
      <div className="mt-8 bg-white border rounded-lg divide-y">
        {PURPOSES.map(([key, label, help]) => (
          <div key={key} className="flex items-start justify-between gap-6 p-5" data-testid={`consent-row-${key}`}>
            <div><p className="text-sm font-semibold">{label}</p><p className="text-xs text-muted-foreground mt-1 leading-relaxed max-w-md">{help}</p></div>
            <Switch checked={!!current[key]?.granted} onCheckedChange={(v) => change(key, v)} data-testid={`consent-switch-${key}`} />
          </div>
        ))}
      </div>
      <section className="mt-12">
        <h3 className="eyebrow">Consent history</h3>
        {history.length === 0 ? <p className="text-sm text-muted-foreground mt-4">No changes recorded yet.</p> : (
          <ul className="mt-4 bg-white border rounded-lg divide-y" data-testid="consent-history">
            {history.map((h) => <li key={h.id} className="flex items-center justify-between px-5 py-3 text-sm"><span>{titleCase(h.purpose)} — <span className={h.granted ? "text-[hsl(var(--accent-forest))]" : "text-muted-foreground"}>{h.granted ? "granted" : "withdrawn"}</span></span><span className="text-muted-foreground text-xs tabular">{dateTime(h.recorded_at)}</span></li>)}
          </ul>
        )}
      </section>
    </div>
  );
}
